module.exports = __webpack_public_path__ + "static/media/sidebar-button.165b0f6d.png";